export default "__VITE_ASSET__NnTiy8aD__"